import Link from './link.vue';
export default Link;


// WEBPACK FOOTER //
// ./src/components/link/index.js